import { BaseMemberActionError } from '../base-member-action-error';

export class EmptyValueError extends BaseMemberActionError {
  constructor(actionClassInstance, value) {
    super(actionClassInstance, `Value "${value}" cannot be empty.`);
  }
}
